import { APP_ROUTES } from "@/Generated/Routes/paths";

import AppRouter from "@/Router";
import { initLoguedAppGuard } from "@/Router/guards";

import { authSSOToken } from "@/Services/TherapyApi/Auth";

import useAuthStore from "../Store";

import { isValidString } from "@/Utils/String";

const authSSOTokenAH = async (token: string): Promise<void> => {
  const authStore = useAuthStore();

  try {
    const response = await authSSOToken(token);

    if (isValidString(response.token)) {
      authStore.setUserToken(response.token);

      const redirect = await initLoguedAppGuard();

      if (redirect) {
        await AppRouter.router.replaceInternal(redirect);
      } else {
        await AppRouter.router.replaceInternal({ name: APP_ROUTES.home.root.name });
      }

      return;
    }
  } catch {
    // An expired or consumed SSO token requires a new login.
  }

  await AppRouter.router.replaceInternal({ name: APP_ROUTES.login.root.name });
};

export default authSSOTokenAH;
